import { useState } from 'react';
import Modal from '../shared/Modal.jsx';
import { useUpdatePayRun } from '../../hooks/usePayRuns.js';
import { useError } from '../shared/ErrorBanner.jsx';

// Admin edit for the metadata fields a draft pay run can change without
// re-generating items: pay_date, provider, notes. Endpoint enforces
// draft-status guard, so the parent should only render this when isDraft.
export default function PayRunMetaEditModal({ run, onClose }) {
  const [payDate, setPayDate] = useState(
    run.pay_date ? new Date(run.pay_date).toISOString().slice(0, 10) : ''
  );
  const [provider, setProvider] = useState(run.provider || 'manual');
  const [notes, setNotes] = useState(run.notes || '');
  const update = useUpdatePayRun();
  const { show } = useError();

  const save = async (e) => {
    e.preventDefault();
    try {
      await update.mutateAsync({
        id: run.id,
        pay_date: payDate ? Date.parse(payDate + 'T00:00:00Z') : null,
        provider,
        notes: notes || null,
      });
      onClose();
    } catch (err) { show(err.message); }
  };

  return (
    <Modal onClose={onClose} title="Edit pay run" icon="ph-pencil-simple">
      <form onSubmit={save}>
        <div className="field">
          <label className="field-label">Pay date</label>
          <input className="field-input" type="date" value={payDate}
            onChange={e => setPayDate(e.target.value)} />
        </div>
        <div className="field">
          <label className="field-label">Provider</label>
          <select className="field-select" value={provider} onChange={e => setProvider(e.target.value)}>
            <option value="manual">manual</option>
            <option value="nacha">NACHA ACH file</option>
            <option value="check">Check (preview)</option>
            <option value="gusto">Gusto</option>
          </select>
        </div>
        <div className="field">
          <label className="field-label">Notes</label>
          <textarea className="field-textarea" value={notes} onChange={e => setNotes(e.target.value)}
            placeholder="Internal notes, anomalies, follow-ups…" />
        </div>
        <button className="btn-sm primary" type="submit" disabled={update.isPending}>
          {update.isPending ? 'Saving…' : 'Save'}
        </button>
      </form>
    </Modal>
  );
}
